import { Controller } from "@hotwired/stimulus"

// Provides a "Group by" dropdown that appends a STATS aggregation pipe
// to the current ES|QL query and re-submits the search.
export default class extends Controller {
  static targets = ["panel", "trigger"]

  #boundOutside = null

  connect() {
    this.#boundOutside = e => {
      if (!this.panelTarget.classList.contains("hidden") && !this.element.contains(e.target)) {
        this.#close()
      }
    }
    document.addEventListener("click", this.#boundOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.#boundOutside)
  }

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.#open() : this.#close()
  }

  apply(event) {
    event.preventDefault()
    const pipe = event.currentTarget.dataset.pipe
    if (!pipe) return
    this.#appendPipe(pipe)
    this.#close()
    this.#submit()
  }

  #open() {
    this.panelTarget.classList.remove("hidden")
    this.triggerTarget.classList.add("active")
  }

  #close() {
    this.panelTarget.classList.add("hidden")
    this.triggerTarget.classList.remove("active")
  }

  #appendPipe(pipe) {
    const textarea = document.querySelector("textarea[name='query']")
    if (!textarea) return
    const base = textarea.value.trim() || "from logs"
    textarea.value = `${base}\n| ${pipe}`
    textarea.dispatchEvent(new Event("input", { bubbles: true }))
  }

  #submit() {
    const form = document.querySelector("textarea[name='query']")?.closest("form")
    if (form) form.requestSubmit()
  }
}
